export default __webpack_public_path__ + "static/media/down.0223aa9b.svg";